import './RestrictedLayout.scss';

import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import { FontAwesomeIcon, FontAwesomeIcons } from "../../constants/fontAwesomeIcons";
import * as Dtos from '../../dtos/Tmd.dtos';
import * as AuthenticationHelper from '../../helpers/authentication';
import { ITmdState } from "../../reducers/index";
import { InlineLoading, OverlayLoading } from "../common/index";
import { DefaultLayout } from "./index";

interface IRestrictedLayoutParams {}

interface IRestrictedLayoutProps extends IRouterProps<IRestrictedLayoutParams> {
    loading?: boolean;
    saving?: boolean;
    noTopMargin?: boolean;
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    trialId?: number;
    institutionId?: number;
    anyMatchpermission?: Dtos.Permission;
    children?: any;
}

interface IRestrictedLayoutActions extends IRouterActions {}

type RestrictedLayoutProps = IRestrictedLayoutProps & IRestrictedLayoutActions;

class RestrictedLayout extends React.PureComponent<RestrictedLayoutProps, any> {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            loading,
            saving,
            permission,
            anyMatchpermission,
            permissions,
            trialId,
            institutionId
        } = this.props;

        let permissionDenied = false;
        if (permissions.length > 0 && permission && !AuthenticationHelper.hasPermission(permissions, permission, trialId, institutionId)) {
            permissionDenied = true;
        }
        if (permissions.length > 0 && anyMatchpermission && !AuthenticationHelper.hasPermissionAnyMatch(permissions, anyMatchpermission)) {
            permissionDenied = true;
        }
        return (
            <DefaultLayout>
                <div 
                    className="restricted-layout-container"
                    style={{ position: loading ? "relative" : undefined }}
                >
                    {
                        loading ?
                            <InlineLoading absoluteCenter={true} size={40} /> :
                            <>
                                {
                                    saving ? 
                                        <OverlayLoading size={40} /> :
                                        null
                                }
                                { 
                                    permissionDenied ?
                                        <div className="alert alert-warning d-flex">
                                            <div className="mr-2">
                                                <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                                            </div>
                                            <span>Permission Denied</span>
                                        </div> : 
                                        this.props.children
                                }
                            </>
                    }
                </div>
            </DefaultLayout>
        );
    }
}


const mapStateToProps = (state: ITmdState, ownProps: RestrictedLayoutProps): IRestrictedLayoutProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {
        match: ownProps.match,
        history: ownProps.history,
        location: ownProps.location,
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children,
        saving: ownProps.saving, 
        noTopMargin: ownProps.noTopMargin
    };
};

const mapDispatchToProps = (dispatch, ownProps: RestrictedLayoutProps): IRestrictedLayoutActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace
    };
};

export default 
    RouterHoc<IRestrictedLayoutParams, RestrictedLayoutProps>((connect(mapStateToProps, mapDispatchToProps)(RestrictedLayout) as unknown as ComponentType<RestrictedLayoutProps>)) as ComponentType<any>;